<template>
	<div>
		<div class="columns is-multiline">
			<div
				v-for="variantEntry in variantNamesAndOptions"
				class="column is-full pb-0">
				<div
					class="columns is-mobile is-multiline width-full is-variable is-0">
					<div class="column is-size-5 is-3 is-half-mobile">
						<div>
							<label
								ref="choices_list_labels"
								class="button is-static"
								:style="
									'min-width:' +
									minLabelWidth +
									';display: flex;border-radius: 0;'
								"
								>{{ variantEntry.name }}:</label
							>
						</div>
					</div>
					<div class="column">
						<div class="select w100-mobile">
							<select
								ref="choices_list_values"
								@change="updateChoices"
								class="font-size-initial w100-mobile"
								style="border-radius: 0px">
								<option
									selected
									disabled
									value="">
									Choose an Option
								</option>
								<option
									v-for="option in variantEntry.options"
									v-html="option"
									:value="option"></option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped>
	.font-size-initial {
		font-size: initial;
	}
</style>
<script type="text/javascript">
	export default {
		props: ["choice_list_prop", "availability_prop", "inventory_prop"],
		data() {
			return {
				isMounted: false,
			};
		},
		mounted() {
			this.$data.isMounted = true;
			this.updateChoices(); // Initialize quantity
		},
		computed: {
			parsedInventory() {
				try {
					return JSON.parse(this.inventory_prop);
				} catch (error) {
					console.error(error);
					return {};
				}
			},
			inventory() {
				try {
					return this.parsedInventory.inventory ?? [];
				} catch (error) {
					console.error(error);
					return [];
				}
			},
			variantDetails() {
				try {
					return this.parsedInventory.variant_details ?? {};
				} catch (error) {
					console.error(error);
					return {};
				}
			},
			choices() {
				// Returning the array that returns the order in which the variants should be displayed.
				// Since this will contain all the dropdowns that should be displayed anyway... and in the correct order.
				try {
					return this.variantDetails.order;
				} catch (error) {
					console.error(error);
					return [];
				}
			},
			variantNamesAndOptions() {
				try {
					const sortOrderOfChoices = this.choices;
					return sortOrderOfChoices.map((variantKey) => {
						let variantOption = {
							name: variantKey,
							options: this.variantDetails.options[variantKey],
						};
						return variantOption;
					});
				} catch (error) {
					console.error(error);
					return [];
				}
			},
			availability() {
				return this.$props.availability_prop ?? false;
			},
			quantity() {
				return parseInt(this.availability);
			},
			minLabelWidth() {
				let minWidth = 0;
				if (this.isMounted) {
					if (this.$refs.choices_list_labels) {
						this.$refs.choices_list_labels.forEach(function (item) {
							item.getBoundingClientRect().width > minWidth
								? (minWidth = item.getBoundingClientRect().width)
								: null /* do nothing*/;
						});
					}
				}
				return minWidth;
			},
		},
		methods: {
			productChoicesUserSelected() {
				let array_of_values = [];

				// When the customer will not be able to select a quantity when only one product is available, the quantity attribute will just be set as 1
				const choicesAreAvailable = Boolean(
					this.$refs.choices_list_values?.length
				);

				if (choicesAreAvailable) {
					//If this.$refs.choices_list_values is not equal to null or undefined
					for (
						let counter = 0,
							count = this.$refs.choices_list_values.length;
						counter < count;
						counter++
					) {
						const choiceValue =
							this.$refs.choices_list_values[counter].value;
						array_of_values.push({
							choice: this.choices[counter],
							value: choiceValue.length ? choiceValue : null,
						});
					}
				}

				if (!choicesAreAvailable && this.quantity === 1) {
					array_of_values.push({ choice: "quantity", value: 1 });
				} else {
					array_of_values.push({
						choice: "quantity",
						value: this.$store.getters.productQuantity,
					});
				}
				return array_of_values;
			},
			selectProductByVariant(choices) {
				let variant = choices
					.filter((choice) => choice.choice !== "quantity")
					.map((choice) => {
						return { [choice.choice]: choice.value };
					});

				let productVariant = this.inventory.find((inventoryEntry) => {
					return variant.every((variantChoice) => {
						const choiceKey = Object.keys(variantChoice)[0];
						const choiceValue = variantChoice[choiceKey];
						return inventoryEntry.variant[choiceKey] === choiceValue;
					});
				});

				return productVariant;
			},
			selectedProductVariant() {
				return this.selectProductByVariant(
					this.productChoicesUserSelected()
				);
			},

			selectedProductVariantPrice() {
				return parseFloat(this.selectedProductVariant()?.price);
			},
			selectedProductVariantCurrency() {
				return this.selectedProductVariant()?.currency;
			},

			updateChoices() {
				const choices = this.productChoicesUserSelected();
				const price = this.selectedProductVariantPrice();
				const currency = this.selectedProductVariantCurrency();

				this.$store.dispatch("set_choices", choices);
				// It would be a more annoying problem if the price was set to zero and the user made a purchase,
				// than if the price was set to infinity and the user chose not to try to make a purchase.
				this.$store.dispatch(
					"set_product_variation_price",
					isNaN(price) ? Infinity : price
				);
				this.$store.dispatch("set_product_variation_currency", currency);
			},
		},
	};
</script>
